/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RecuperarSenhaRouteImport } from './routes/recuperar-senha'
import { Route as ContaRouteImport } from './routes/conta'
import { Route as CompletarCelularRouteImport } from './routes/completar-celular'
import { Route as CadastroRouteImport } from './routes/cadastro'
import { Route as AbrirContaRouteImport } from './routes/abrir-conta'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LTokenRouteImport } from './routes/l.$token'
import { Route as AuthImportSessionRouteImport } from './routes/auth.import-session'
import { Route as AuthGoogleContinueRouteImport } from './routes/auth.google.continue'

const RecuperarSenhaRoute = RecuperarSenhaRouteImport.update({
  id: '/recuperar-senha',
  path: '/recuperar-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const ContaRoute = ContaRouteImport.update({
  id: '/conta',
  path: '/conta',
  getParentRoute: () => rootRouteImport,
} as any)
const CompletarCelularRoute = CompletarCelularRouteImport.update({
  id: '/completar-celular',
  path: '/completar-celular',
  getParentRoute: () => rootRouteImport,
} as any)
const CadastroRoute = CadastroRouteImport.update({
  id: '/cadastro',
  path: '/cadastro',
  getParentRoute: () => rootRouteImport,
} as any)
const AbrirContaRoute = AbrirContaRouteImport.update({
  id: '/abrir-conta',
  path: '/abrir-conta',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LTokenRoute = LTokenRouteImport.update({
  id: '/l/$token',
  path: '/l/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthImportSessionRoute = AuthImportSessionRouteImport.update({
  id: '/auth/import-session',
  path: '/auth/import-session',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthGoogleContinueRoute = AuthGoogleContinueRouteImport.update({
  id: '/auth/google/continue',
  path: '/auth/google/continue',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/abrir-conta': typeof AbrirContaRoute
  '/cadastro': typeof CadastroRoute
  '/completar-celular': typeof CompletarCelularRoute
  '/conta': typeof ContaRoute
  '/recuperar-senha': typeof RecuperarSenhaRoute
  '/auth/import-session': typeof AuthImportSessionRoute
  '/l/$token': typeof LTokenRoute
  '/auth/google/continue': typeof AuthGoogleContinueRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/abrir-conta': typeof AbrirContaRoute
  '/cadastro': typeof CadastroRoute
  '/completar-celular': typeof CompletarCelularRoute
  '/conta': typeof ContaRoute
  '/recuperar-senha': typeof RecuperarSenhaRoute
  '/auth/import-session': typeof AuthImportSessionRoute
  '/l/$token': typeof LTokenRoute
  '/auth/google/continue': typeof AuthGoogleContinueRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/abrir-conta': typeof AbrirContaRoute
  '/cadastro': typeof CadastroRoute
  '/completar-celular': typeof CompletarCelularRoute
  '/conta': typeof ContaRoute
  '/recuperar-senha': typeof RecuperarSenhaRoute
  '/auth/import-session': typeof AuthImportSessionRoute
  '/l/$token': typeof LTokenRoute
  '/auth/google/continue': typeof AuthGoogleContinueRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/abrir-conta'
    | '/cadastro'
    | '/completar-celular'
    | '/conta'
    | '/recuperar-senha'
    | '/auth/import-session'
    | '/l/$token'
    | '/auth/google/continue'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/abrir-conta'
    | '/cadastro'
    | '/completar-celular'
    | '/conta'
    | '/recuperar-senha'
    | '/auth/import-session'
    | '/l/$token'
    | '/auth/google/continue'
  id:
    | '__root__'
    | '/'
    | '/abrir-conta'
    | '/cadastro'
    | '/completar-celular'
    | '/conta'
    | '/recuperar-senha'
    | '/auth/import-session'
    | '/l/$token'
    | '/auth/google/continue'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AbrirContaRoute: typeof AbrirContaRoute
  CadastroRoute: typeof CadastroRoute
  CompletarCelularRoute: typeof CompletarCelularRoute
  ContaRoute: typeof ContaRoute
  RecuperarSenhaRoute: typeof RecuperarSenhaRoute
  AuthImportSessionRoute: typeof AuthImportSessionRoute
  LTokenRoute: typeof LTokenRoute
  AuthGoogleContinueRoute: typeof AuthGoogleContinueRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/recuperar-senha': {
      id: '/recuperar-senha'
      path: '/recuperar-senha'
      fullPath: '/recuperar-senha'
      preLoaderRoute: typeof RecuperarSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conta': {
      id: '/conta'
      path: '/conta'
      fullPath: '/conta'
      preLoaderRoute: typeof ContaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/completar-celular': {
      id: '/completar-celular'
      path: '/completar-celular'
      fullPath: '/completar-celular'
      preLoaderRoute: typeof CompletarCelularRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cadastro': {
      id: '/cadastro'
      path: '/cadastro'
      fullPath: '/cadastro'
      preLoaderRoute: typeof CadastroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/abrir-conta': {
      id: '/abrir-conta'
      path: '/abrir-conta'
      fullPath: '/abrir-conta'
      preLoaderRoute: typeof AbrirContaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/l/$token': {
      id: '/l/$token'
      path: '/l/$token'
      fullPath: '/l/$token'
      preLoaderRoute: typeof LTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/import-session': {
      id: '/auth/import-session'
      path: '/auth/import-session'
      fullPath: '/auth/import-session'
      preLoaderRoute: typeof AuthImportSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/google/continue': {
      id: '/auth/google/continue'
      path: '/auth/google/continue'
      fullPath: '/auth/google/continue'
      preLoaderRoute: typeof AuthGoogleContinueRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AbrirContaRoute: AbrirContaRoute,
  CadastroRoute: CadastroRoute,
  CompletarCelularRoute: CompletarCelularRoute,
  ContaRoute: ContaRoute,
  RecuperarSenhaRoute: RecuperarSenhaRoute,
  AuthImportSessionRoute: AuthImportSessionRoute,
  LTokenRoute: LTokenRoute,
  AuthGoogleContinueRoute: AuthGoogleContinueRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
